import { DepInjMixin, requires } from '@APP/mixins/dependency';
import { InsuranceService } from '@APP/services/insurance-service';
import { QuestionsService } from '@APP/services/questions-service';
import { t } from '@APP/utils/locale';
import { css, html, nothing } from 'lit';
import { customElement, queryAll } from 'lit/decorators';
import { commonPopupStyle } from '../../styles/common-style';
import { DeviceAwareComponent } from '../components/device-aware-component';
import { Icon1, OpenIcon, Icon3, Icon2, Icon4 } from '../icons/icons';

type deps = {
  insuranceService: InsuranceService;
  questionsService: QuestionsService;
};

const map = [
  {
    id: 1,
    title: 'Full Payment',
    text: `The total policy premium for a policy term may be paid in full at the time a new policy is
written or upon the receipt of a renewal billing notice.`,
    iconSvg: Icon1,
  },
  {
    id: 2,
    title: 'Installment Payments',
    text: `The total policy premium for a policy term may be paid through one of the Company’s
installment payment plans. A handling fee of $1.00 will be assessed for each installment
payment paid by a recurring electronic fund transfer (EFT). A handling fee of $5.00 will be
assessed for installment payments paid by all other methods.`,
    iconSvg: Icon2,
  },
  {
    id: 3,
    title: 'Processing Fee',
    text: `A processing fee of 2.9% plus $0.30 per transaction will apply when the premium is paid by debit or credit card. This fee covers Stripe's charges as a third-party payment processor.
          Alternatively, if the premium is paid via bank account, a flat processing fee of $0.95 per transaction will apply, covering GoCardless Ltd.'s fees as a third-party payment servicer.`,
    iconSvg: Icon2,
  },
  {
    id: 4,
    title: 'Insufficient Funds',
    text: `The Company reserves the right to impose a fee of $30.00 for any premium payment, fees,
or other charges due the Company, regardless of payment method, that are unable to be
processed due to insufficient funds or the unavailability or inaccessibility of funds.`,
    iconSvg: Icon3,
  },
  {
    id: 5,
    title: 'Late Payment Fee',
    text: `A late payment fee of $15.00 will be assessed for any payment not received on the third day
past the billing due date.`,
    iconSvg: Icon4,
  },
];
let faqMap = [
  { id: 6, iconSvg: Icon1, title: 'What are the payment methods you accept?', text: 'Ahoy! provides convenient options to fit your lifestyle. You can pay for your boat insurance coverage via Bank account (ACH) or Credit card. If you decide to pay via your bank account or credit card, you also have the option of paying your premium Annually and receive a 5% discount, or Monthly.' },
  { id: 7, iconSvg: Icon1, title: 'How do I change my payment details?', text: 'An insured can change their payment method (credit card and ACH) and payment details credit card through the MyAhoy! section on the website or the Ahoy! mobile app. You can also call customer service at 1-855-665-2469 Monday to Friday 9AM to 5PM EST. Additionally, you can chat with us on our website during the same business hours or send us an email at firstmate@ahoy.insure.' },
  { id: 8, iconSvg: Icon1, title: 'Will you use my credit history? Will my credit score be affected by applying for a policy?', text: 'In some cases we might check your credit history. Your credit score isn’t impacted when Ahoy! checks it once you’ve applied for coverage. This is considered a “soft” inquiry, and soft inquiries don’t affect your credit score.' },
  { id: 9, iconSvg: Icon2, title: 'Is there a discount for paying policy in full? ', text: 'Yes, you will get a 5% discount for paying in full. ' },
  { id: 10, iconSvg: Icon3, title: 'What is auto pay?', text: 'This payment option automatically withdraws a scheduled payment on your due date from either your credit card or ACH.' },
  { id: 11, iconSvg: Icon4, title: 'Is there an extra cost for choosing an installment plan?', text: 'Yes. The charge added to an ACH monthly payment is $1 per installment and for credit card $5 per installment. You can avoid installment fees by choosing the pay in full option at check out.' },
  { id: 12, iconSvg: Icon2, title: 'Which credit card can I use?', text: 'Visa, Mastercard, Discover, American Express' },
  { id: 13, iconSvg: Icon1, title: 'How do I set up my payments?', text: 'Your payments will be set up at time of purchase either online or with your FirstMate agent.' },
  { id: 14, iconSvg: Icon1, title: 'Can I set my policy up for auto-bill / recurring payments? ', text: 'Yes. Upon purchasing the policy, if you choose an installment plan, you will be charged a downpayment followed by 10 monthly equal payments.' },
  { id: 15, iconSvg: Icon2, title: 'Can I change the date my payment is due?', text: "The due date of a payment is based on the effective date of the policy, currently we don't offer the option to change the due date of your bill." },
  { id: 16, iconSvg: Icon3, title: 'Can I mail in a payment?', text: 'No, all policies will be set up on automatic payments via ACH or credit at the time of purchase.' },
  { id: 17, iconSvg: Icon4, title: 'Is it possible to make changes to my boat policy mid-term?', text: 'Yes, mid-term adjustments are available and your policy premium may or may not be affected.' },
  { id: 18, iconSvg: Icon1, title: 'How will mid-year changes to my boat policy effect billing and payments? ', text: 'Your billing will be updated to reflect the changes made. If a reduction in premium is indicated a refund will be issued. If an increase in premium is indicated, we will take payment for the requested change at the time the change was made' },
  { id: 19, iconSvg: Icon2, title: 'If I choose to sell my boat mid-year and cancel my coverage, will there be any penalty?', text: 'There are NO penalties if you wish to cancel before your renewal date. You will be refunded any unused premium from the policy term.' },
  { id: 20, iconSvg: Icon3, title: 'I received a cancellation notice due to non-payment of premium. Will I be able to pay now and reinstate the policy?', text: 'It is important to not fall behind on payments and risk the policy getting cancelled which will lead to lack of coverage. Ahoy! sends payment notifications ahead of each payment and, specifically, ahead of the policy renewal date. In these notifications we include the payment details on file (while maintaining privacy) as well as instructions about how to update the payment details if needed. In the case of non-payment the policy will be cancelled and you will have 15 days post cancellation where reinstatement will be allowed with a signed No Known Loss letter. In the case of reinstatement a late payment fee of $45 will be assessed.' },
  { id: 21, iconSvg: Icon4, title: 'What discounts are available?', text: 'You will get a 5% discount to pay your policy premium in full. Your prior boating experience may also provide you some additional savings.' },
  { id: 22, iconSvg: Icon1, title: 'What is Paperless Billing and Documentation?', text: 'Paperless means you will receive electronic versions of what would have been paper mailed. You will receive emails for billing reminders, changes made, and general policy information.' },
  { id: 23, iconSvg: Icon2, title: 'How do i get my policy documents?', text: 'At Ahoy we value our natural resources, so all of our policies are set up on paperless billing and documentation. We will email you all of your documents when a new policy is bound, at renewal or at your request, In addition, all documents are available in the MyAhoy! area of the website.' },
];


@requires(QuestionsService.serviceName, InsuranceService.serviceName)
@customElement('payment-terms-and-conditions-popup')
export class PaymentTermsAndConditionsPopup extends DepInjMixin<deps>(DeviceAwareComponent) {
  static get desktopStyles() {
    return [];
  }
  static get mobileStyles() {
    return [css`
    .content{
      padding-block-start:unset;
    }
    .panel{
      padding: 0 8rem 0 1.25rem;
    }
    .content {
      height:60vh;
    }
    `,
    ];
  }
  
  static get baseStyles() {
    return [commonPopupStyle, css`
      :host{
        --popup-overflow:auto;
      }

    h2 {
      color: #0D2D5F;
      font-family: Satoshi;
      font-size: 4rem;
      font-style: normal;
      font-weight: 700;
      line-height: 5.5rem;
      letter-spacing: 0em;
      text-align: left;
      margin: 0;
      margin-block-end: 1.25rem;
    }

    h3 {
      color: #0D2D5F;
      font-family: Satoshi;
      font-size: 3rem;
      font-style: normal;
      font-weight: 700;
      line-height: 4rem;
      letter-spacing: 0em;
      text-align: left;
      margin: 0;
      margin-block-end: 3rem;
    }
    
    h3.bottom {
      margin-block-start:6.25rem;
    }

    .content {
      max-width: 102rem;
      max-height: 100rem;
      justify-content: center;
      padding: 2.75rem;
      background-color: #F5F6F9;
      border-radius: 1.25rem;
    }

    .single-button-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .icon-container {
      max-width: 6.25rem;
      max-height: 6.25rem;
      margin-inline-start: 2.5rem;
      margin-inline-end: 1.25rem;
    }

    .icon-container svg{
      max-width: 6.25rem;
      max-height: 6.25rem;
    }

    .open-icon-container {
      max-width: 1rem;
      max-height: 2rem;
      margin-inline-end: 2rem;
    }

    .divider-container {
      width: 100%;
    }

    .divider {
      border-width: 0;
      width: 100%;
      background: #DDDCE5;
      height: 0.125rem;
    }

    button.accordion {
      background-color: unset;
      color: #121213;
      cursor: pointer;
      padding: 2rem;
      width: 100%;
      border: none;
      outline: none;
      font-size: 2rem;
      transition: 0.4s;
      font-family: Satoshi;
      font-style: normal;
      font-weight: 500;
      line-height: 3rem;
      letter-spacing: 0em;
      text-align: left;
    }

    .active,
    .single-button-container:hover {
      border-radius: 1.25rem 1.25rem 0 0;
    }

    .panel {
      padding: 0 6.25rem 0 8.5rem;
      background-color: white;
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.2s ease-out;
      border-radius: 0 0 1.25rem 1.25rem;
    }

    .complete-details-header {
      margin-block-start: 6.25rem;
      margin-block-end: 2.75rem;
      font-family: Satoshi;
      font-size: 3rem;
      font-style: normal;
      font-weight: 700;
      line-height: 4rem;
      letter-spacing: 0;
      text-align: left;
    }

    p {
      font-family: Satoshi;
      font-size: 2rem;
      font-style: normal;
      font-weight: 500;
      line-height: 3rem;
      letter-spacing: 0;
      text-align: left;
    }

    .panel p {
      margin-block-end: 2.75rem;
      margin-block-start: 0;
    }

    .p-header {
      margin-block-start: 2.5rem;
      margin-block-end: 0;
      font-size: 2.5rem;
    }

    .p-header:first-of-type {
      margin-block-start: 0;
    }

    .p-text {
      margin-block-start: 0;
    }

    .active {
      background-color: white;
      border-radius: 1.25rem 1.25rem 0 0;
    }
  `];
  };

  @queryAll('.panel')
  private panelElements!: any[];

  @queryAll('.single-button-container')
  private accordionElements!: any[];

  connectedCallback() {
    super.connectedCallback();
  }

  getAccordionData(accordionIndex: string, faq: boolean = false) {
    const relevantMap = faq ? faqMap : map;
    const index = parseInt(accordionIndex);
    return relevantMap.find((el) => el.id === index);
  }

  handleClick(e: MouseEvent) {
    if (!e) return;
    const target = e.currentTarget as HTMLElement;
    const accordionIndex = target.dataset.index || '';
    const accordionData = parseInt(accordionIndex) > map.length ? this.getAccordionData(accordionIndex, true) : this.getAccordionData(accordionIndex);
    const panelId = accordionData!.id;
    const accordion = panelId ? this.accordionElements[panelId - 1] : nothing;
    const isActive = accordion.classList.contains('active');
    this.accordionElements.forEach(e => e.classList.remove('active'));
    this.panelElements.forEach(e => e.style.maxHeight = null);
    if (!isActive) {
      const panel = panelId ? this.panelElements[panelId - 1] : nothing;
      accordion.classList.add('active');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  }

  filterFaqMap({ filterType = 'noAnnualDiscountInCA' }) {
    const regenerateFaqMapIds = () => {
      faqMap = faqMap.map((el, index) => {
        el.id = index + 6;
        return el;
      });
    };
    switch (filterType) {
      case 'noAnnualDiscountInCA': {
        const isInNoAnnualDiscountStates = this.deps.questionsService.checkInNoAnnualDiscountStates();
        if (isInNoAnnualDiscountStates) {
          faqMap = faqMap.filter((el) => ![9, 21].includes(el.id));
          regenerateFaqMapIds();
        }
        break;
      }
      default:
        break;
    }
  }

  renderLayout() {
    return html`
 <div class="content">
    <h2>Payment terms and conditions</h2>

    <h3>Complete details</h3>

    <div class="buttons-container">
      ${map.map((el, index) => {
    const rowIndex = index + 1;
    return html`
        <div class="single-button-container"
        @click=${this.handleClick}
        data-index=${rowIndex}>
          <div class="icon-container">
            ${el.iconSvg}
          </div>
          <button class="accordion">${t(el.title)}</button>
          <div class="open-icon-container">
            ${OpenIcon}
          </div>
        </div>
        <div class="panel">
          <p>${t(el.text)}</p>
        </div>
        <div class="divider-container">
          <hr class="divider">
        </div>`;
  })}
      
    <h3 class="bottom">Frequently asked questions</h3>

      <div class="buttons-container">
      ${this.filterFaqMap({})}
      ${faqMap.map((el, index) => {
    const rowIndex = (index + 1) + 5;
    return html`
        <div class="single-button-container"
        @click=${this.handleClick}
        data-index=${rowIndex}>
          <button class="accordion">${t(el.title)}</button>
          <div class="open-icon-container">
            ${OpenIcon}
          </div>
        </div>
        <div class="panel">
          <p>${t(el.text)}</p>
        </div>
        <div class="divider-container">
          <hr class="divider">
        </div>`;
  })}
  </div>
    `;
  }

  renderContent() {
    return this.renderLayout();
  }
}
